// src/components/Footer.jsx
import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Link as MuiLink,
  Divider,
  Stack,
  IconButton,
  Button,
  Container
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { servicesData } from '../pages/servicesData';

const Footer = () => {

  const navigate = useNavigate();

  const handleFooterNav = (path) => {
    window.scrollTo({ top: 0, behavior: "auto" });
    navigate(path);
  };
  return (
    <Box component="footer" sx={{ backgroundColor: '#1b5e20', color: 'white', pt: 6, pb: 4 }}>
      <Container
        maxWidth="lg"
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >

        <Grid container spacing={4}>
          {/* Logo & Description */}
          <Grid item xs={12} md={4}>   {/* Logo */}
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <img
                src="/images/logo.jpeg"
                alt="KRM Logo"
                style={{ height: 50, width: 50, objectFit: 'contain', borderRadius: '8px' }}
              />
              <Typography variant="h4" sx={{ fontWeight: 'bold', fontFamily: 'Georgia, serif', fontSize: 22 }}>
                KRM Landscape
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: '#c8e6c9', fontSize: 16, maxWidth: 320 }}>
              We specialize in innovative landscape design, development, and maintenance bringing nature closer to modern spaces.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} md={2}>    {/* Quick Links */}
            <Typography variant="h4" sx={{ fontFamily: 'Georgia, serif', mb: 2, fontSize: 18 }}>
              Quick Links
            </Typography>
            {['Home', 'About Us', 'Services', 'Gallery', 'Contact'].map((label, index) => (
              <MuiLink
                key={label}
                component={Link}
                to={['/', '/about', '/services', '/gallery', '/contact'][index]}
                underline="none"
                color="inherit"
                sx={{
                  display: 'block',
                  mb: 1,
                  color: '#e8f5e9',
                  fontSize: 18,
                  '&:hover': { color: '#a5d6a7' }
                }}
              >
                {label}
              </MuiLink>
            ))}
          </Grid>

          {/* Services */}
          <Grid item xs={6} md={3}>    {/* Services */}

            <Typography
              variant="h4"
              sx={{
                fontFamily: "Georgia, serif",
                mb: 2,
                fontSize: 18,
              }}
            >
              Services
            </Typography>

            {servicesData.map((service, i) => (
              <Typography
                key={i}
                component="button"
                onClick={() => handleFooterNav(service.path)}
                variant="body1"
                sx={{
                  all: "unset",
                  cursor: "pointer",
                  display: "block",
                  mb: 1,
                  fontSize: 16,
                  color: "#c8e6c9",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    color: "#ffffff",
                    transform: "translateX(4px)",
                  },
                }}
              >
                • {service.name}
              </Typography>
            ))}
          </Grid>


          {/* Contact Info */}
          <Grid item xs={12} md={3}>   {/* Contact */}

            <Typography variant="h4" sx={{ fontFamily: 'Georgia, serif', mb: 2, fontSize: 18 }}>
              Contact
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <LocationOnIcon sx={{ color: '#a5d6a7' }} />
              <Typography variant="body1" sx={{ color: '#c8e6c9', fontSize: 15 }}>
                KRM Landscape <br />BLD - 98 , RM - 216 , NEW MHADA COLONY <br />VIJAY MALANG CO OP HSG SOC MANKHURD <br />MUMBAI 400043, Maharashtra, India
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <PhoneIcon sx={{ color: '#a5d6a7' }} />
              <Typography variant="body1" sx={{ color: '#c8e6c9', fontSize: 15 }}>
                +91 9307068889 /+91 9730566577 /+91 9421033554
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <EmailIcon sx={{ color: '#a5d6a7' }} />
              <Typography variant="body1" sx={{ color: '#c8e6c9', fontSize: 15 }}>
                krmlandscape@gmail.com
              </Typography>
            </Stack>

            {/* Social Icons */}
            <Stack direction="row" mt={2} >
              {/* <IconButton
                component="a"
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#a5d6a7",
                  transition: "transform 0.2s ease",
                  "&:hover": {
                    color: "#ffffff",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <FacebookIcon />
              </IconButton> */}

              <Button
                component="a"
                href="https://www.instagram.com/krm_3_landscape?igsh=MW85d2loeHVhZnZucw=="
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<InstagramIcon />}
                sx={{
                  textTransform: "none",
                  color: "#a5d6a7",
                  border: "1px solid #a5d6a7",
                  borderRadius: "20px",
                  px: 2,
                  "&:hover": {
                    color: "#fff",
                    borderColor: "#fff",
                    backgroundColor: "rgba(255,255,255,0.1)",
                  },
                }}
              >
                Follow on Instagram
              </Button>

              {/* <IconButton
                component="a"
                href="https://www.linkedin.com/in/shardul-kolte-956712272/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#a5d6a7",
                  transition: "transform 0.2s ease",
                  "&:hover": {
                    color: "#ffffff",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <LinkedInIcon />
              </IconButton> */}
            </Stack>

          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: '#66bb6a' }} />

        {/* Bottom Section */}
        <Box textAlign="center">
          <Typography variant="body2" sx={{ color: '#c8e6c9', fontSize: 14 }}>
            © {new Date().getFullYear()} KRM Landscape. All rights reserved.
          </Typography>
          {/* <Typography variant="body2" sx={{ color: '#c8e6c9', fontSize: 14 }}>
            Designed by{' '}
            <MuiLink
              href="https://yourdesignerwebsite.com"
              target="_blank"
              underline="hover"
              sx={{ color: '#a5d6a7' }}
            >
              YourDesignStudio
            </MuiLink>
          </Typography> */}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
